import { CrudModel } from './_crud';
import { crudCreate, crudGet, crudRead } from "./_request";
import companyModel from './company.model';
export class UserModel extends CrudModel {
	constructor() {
		//super('admin/user');
		super('admin/user', [], [{ fieldKey: 'company', model: companyModel }]);
	}

	async anonimizar(data: any) {
		//console.log('custom action', data);
		try {
			const endpoint = 'admin/user/lgpdupdate';
			return (await crudCreate(endpoint, { id: data.id })); // await before return allows error catching
		} catch (error) {
			await super.handleError(error);
		}
	}

	async addCompany(userId: number, companyId: number) {
		try {
			const endpoint = 'admin/user/addCompany';
			return (await crudCreate(endpoint, { id: userId, companyId })); // await before return allows error catching
		} catch (error) {
			await super.handleError(error);
		}
	}

	async addCompanies(userId: number) {
		try {
			const endpoint = 'admin/user/addCompanies';
			return (await crudCreate(endpoint, { id: userId })); // await before return allows error catching
		} catch (error) {
			await super.handleError(error);
		}
	}

	async getCompanies(user: any) {
		try {
			//const endpoint = 'admin/user';
			return (await this.post(null, 'getCompanies', { id: user.id })); // await before return allows error catching
		} catch (error) {
			await super.handleError(error);
		}
	}

	async deleteCompany(id: number) {
		try {
			//const endpoint = 'admin/user';
			return (await this.post(null, 'deleteCompany', { id })); // await before return allows error catching
		} catch (error) {
			await super.handleError(error);
		}
	}
}

export default new UserModel();
